module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-font-fill-3fa31288.svg";